import React , { Component } from 'react';
import Demandeur from './forms/demandeur';
import Conjoint from './forms/conjoint';
import Ressources from './forms/ressources';
import RevenusImposables from './forms/declaration-revenus-imposable.js';
import Resultats from './forms/resultat.js';


class Step extends Component {

	render () {
		const hasEnfant = Object.keys(this.props.individus).length >0 ;
		// routage des etapes
		switch (this.props.step){
			case 1 : 
				return (
					<Demandeur validateStep={this.props.validateStep}  restart={this.props.restart}/>
				);
				break;
			case 2:
				/* Individus : toute personne n'etant pas conjoint ni demandeur */
				
				const enCouple = this.props.famille.en_couple;
				return (
					<Conjoint validateStep={this.props.validateStep} 
						hasEnfant={hasEnfant}
						enCouple={enCouple}
						previousStep={this.props.previousStep}
						restart={this.props.restart} />
				);
				break;
			case 3:
				return (
					<Ressources validateStep={this.props.validateStep} 
						individus={this.props.individus}
						conjoint={this.props.conjoint}
						famille ={this.props.famille}
						previousStep={this.props.previousStep}
						restart={this.props.restart}  />
				);
				break;
			case 4: 
				return (
					<Resultats
						validateStep={this.props.validateStep}
						individus={this.props.individus}
		      			conjoint={this.props.conjoint}
		      			demandeur={this.props.demandeur}
		      			famille ={this.props.famille}
		      			foyer_fiscal ={this.props.foyer_fiscal}
		      			menage={this.props.menage}
		      			restart ={this.props.restart}
		      			definedRessources ={this.props.definedRessources}
						ineligibleByAge ={this.props.ineligibleByAge}
						/>
				);
				break;
			case 5: 
				return (
					<RevenusImposables
						validateStep={this.props.validateStep}
						individus={this.props.individus}
						demandeur={this.props.demandeur}
						conjoint={this.props.conjoint}
						returnToResult={this.props.previousStep}
					/>
				)
				break; //revenu imposable N-2
			default :
				return (
					<div className="step">
					<h3> Step : {this.props.step} </h3>
				
					</div>
				); break;
		}


	}
}

export default Step;
